import React from 'react';
import PropTypes from 'prop-types';
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import { ZERO_TO_SIX_PLUS_OPTIONS_MAX, ZERO_TO_SIX_PLUS_OPTIONS_MIN } from 'constants/filterOptions';
import useFilterStore from 'zustandStore/useFilterStore';
import RpBasicRangeFilter from 'components/commons/RpBasicRangeFilter';

const BathFilter = React.memo(function BathFilter(props) {
    const baths = useFilterStore(state => state.filters[props.comparableType].baths);
    const setFilters = useFilterStore(state => state.setFilters);

    return (
        <RpBasicRangeFilter
            label="Bath"
            displayValue={SearchFilterUtil.formatBedBathCarRangeDisplay(baths?.min, baths?.max)}
            active={!!(baths?.min || baths?.max)}
            minOptions={ZERO_TO_SIX_PLUS_OPTIONS_MIN}
            maxOptions={ZERO_TO_SIX_PLUS_OPTIONS_MAX}
            minValue={baths?.min}
            maxValue={baths?.max}
            onChange={({min, max}) => setFilters(props.comparableType, { baths: { min: min.value, max: max.value } })}
            isDropdown={props.isDropdown}
            icon={BathtubOutlinedIcon}
        />
    );
});

BathFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    isDropdown: PropTypes.bool
};

export default BathFilter;
